<template>
  <div class="filter-item">
    <div
      class="filter-item__header"
      :class="{ hide: !isShownSpecification }"
      @click="toggleShowSpecification"
    >
      <p class="filter-item__title">
        {{ getLocalizedName(specification.name) }}
      </p>
      <div class="filter-item__arrow">
        <img src="~/assets/icons/arrow-down.svg" alt="change display" />
      </div>
    </div>
    <div class="filter-item__body" :class="{ active: isShownAllOptions }">
      <CheckboxSpecification
        v-for="option in specification.options"
        :key="option.id"
        class="filter-item__checkbox"
        :specification-id="specification.id.toString()"
        :option-id="option.id.toString()"
      >
        {{ getLocalizedName(option.value) }}
      </CheckboxSpecification>
      <ShowAll
        v-if="specification.options.length > 5"
        @click="toggleShowAllOptions"
      />
    </div>
  </div>
</template>

<script setup>
import CheckboxSpecification from "~/modules/productCatalog/ui/components/filter/bar/CheckboxSpecification.vue";
import ShowAll from "~/modules/shared/buttons/ShowAll.vue";

const props = defineProps({
  specification: { type: Object, required: true },
});

const isShownSpecification = ref(true);
const isShownAllOptions = ref(false);

function toggleShowSpecification() {
  isShownSpecification.value = !isShownSpecification.value;
}

function toggleShowAllOptions() {
  isShownAllOptions.value = !isShownAllOptions.value;
}
</script>

<style lang="scss" scoped>
.filter-item {
  border-bottom: 1px solid var(--color-sky-base);

  padding: 8px 0;

  &:last-child {
    border: none;

    padding-bottom: 0;
  }

  @include bigMobile {
    background-color: var(--color-sky-lightest);
    border: none;
    border-radius: 16px;
  }

  &__header {
    @include flex-container(row, space-between, flex-start);

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    padding: 0 8px;
    margin-bottom: 8px;

    cursor: pointer;

    &.hide {
      margin-bottom: 0;

      & > .filter-item__arrow {
        transform: rotateZ(0deg);
      }

      & + .filter-item__body {
        height: 0;
      }
    }
  }

  &__title {
    @include bigMobile {
      @include font(14, 20);
    }
  }

  &__arrow {
    flex: 0 0 auto;

    transform: rotateZ(180deg);

    transition: transform 0.2s ease-in-out;
  }

  &__body {
    @include flex-container(column, flex-start);
    height: auto;

    overflow: hidden;

    &:not(.active) {
      .filter-item__checkbox {
        &:nth-child(n + 6) {
          display: none;
        }
      }
    }
  }
}
</style>
